import { useState, useRef } from "react";
import { useNavigate } from 'react-router-dom'
import user from "../Models/user"
import api, {setApi} from "../utils/api";
import './pos.css';
import logo2 from '../assets/img/logo2.png'
import background from '../assets/img/background.png'

const LOGIN_CONFIRM = process.env.REACT_APP_LOGIN_CONFIRM === 'true';

export default function Login() {
    const usernameRef = useRef(null)
    const passwordRef = useRef(null)

    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const [showConfirm, setShowConfirm] = useState(false)
    const [confirmData, setConfirmData] = useState(null)

    function getCredentials() {
        return {
            username: usernameRef.current?.value || '',
            password: passwordRef.current?.value || '',
        }
    }

    function doLogin() {
        setLoading(true)
        setError('')

        const { username, password } = getCredentials()

        window.axios.post('/login', { username, password })
            .then(response => {
                localStorage.setItem('token', response.data.token)
                setApi()

                function afterAuth() {
                    // Provjeri shift status nakon prijave
                    window.axios.get('/shift-status')
                        .then(shiftRes => {
                            const s = shiftRes.data
                            if (s.needs_confirmation) {
                                navigate('/shift-confirm')
                            } else if (s.is_blocked) {
                                navigate('/shift-block')
                            } else {
                                navigate('/')
                            }
                        })
                        .catch(() => {
                            navigate('/')
                        })
                }

                user.authenticated(response.data.user, afterAuth)
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setError('Pogrešno korisničko ime ili lozinka.')
                } else if (error.response?.status === 422) {
                    setError(error.response?.data?.message || 'Neispravan unos podataka.')
                } else if (error.response?.data?.message) {
                    setError(error.response.data.message)
                } else {
                    setError('Došlo je do greške prilikom prijave. Pokušajte ponovo.')
                }
                if (passwordRef.current) {
                    passwordRef.current.value = ''
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    function handleSubmit(event) {
        event.preventDefault()

        if (!LOGIN_CONFIRM) {
            doLogin()
            return
        }

        setLoading(true)
        setError('')

        const { username, password } = getCredentials()

        window.axios.post('/login-check', { username, password })
            .then(response => {
                setConfirmData(response.data)
                setShowConfirm(true)
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setError('Pogrešno korisničko ime ili lozinka.')
                } else if (error.response?.status === 422) {
                    setError(error.response?.data?.message || 'Neispravan unos podataka.')
                } else {
                    setError('Došlo je do greške. Pokušajte ponovo.')
                }
                if (passwordRef.current) {
                    passwordRef.current.value = ''
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    function handleConfirm() {
        setShowConfirm(false)
        setConfirmData(null)
        doLogin()
    }

    function handleCancel() {
        setShowConfirm(false)
        setConfirmData(null)
    }

    return (
        <>
            <div className="hide-print login-bg fixed w-full h-screen left-0 top-0 z-10 flex flex-wrap justify-center content-center p-24 bg-cover" style={{backgroundImage: `url(${background})`}}>
                <div className="fixed glass w-full h-screen left-0 top-0 z-0 opacity-100"></div>
                <div className="w-96 rounded-sm bg-white shadow-xl overflow-hidden z-10 opacity-100 scale-100">
                    <div className="text-left w-full text-sm p-6 overflow-auto">
                        <div className="text-center mb-5">
                            <img src={logo2} className="w-60 m-auto" />
                            <h2 className="text-xl font-semibold mt-4 mb-4">Prijava</h2>
                        </div>
                        { error !== '' &&
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-5" role="alert">
                                <strong className="font-bold">Prijava nije uspješna! </strong>
                                <span className="block sm:inline">{ error }</span>
                                <span onClick={() => setError('')} className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer">
                                    <svg className="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
                                </span>
                            </div>
                        }
                        <form id="login-form" onSubmit={handleSubmit}>
                            <div className="flex flex-col mb-4">
                                <label className="mb-2 uppercase font-semibold text-sm text-grey-darkest" htmlFor="username">Korisnik</label>
                                <input ref={usernameRef} autoComplete="username" className="border py-2 px-3 text-grey-darkest rounded" type="text" name="username" id="username" />
                            </div>
                            <div className="flex flex-col mb-4">
                                <label className="mb-2 uppercase font-semibold text-sm text-grey-darkest" htmlFor="password">Lozinka</label>
                                <input ref={passwordRef} autoComplete="current-password" className="border py-2 px-3 text-grey-darkest rounded" type="password" name="password" id="password" />
                            </div>
                        </form>
                    </div>
                    <div className="p-4 w-full">
                        <button form="login-form" disabled={loading} className="bg-primary text-white text-lg px-4 py-3 rounded-sm w-full focus:outline-none hover:bg-yellow-700">
                            { loading ? 'Provjera...' : 'Prijava'}
                        </button>
                    </div>
                </div>
            </div>

            {/* Confirmation Modal */}
            {showConfirm && confirmData && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
                        <div className="text-center">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-cyan-100 mb-4">
                                <svg className="h-6 w-6 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">Potvrda prijave</h3>
                            <p className="text-gray-600 mb-1">Prijavljujete se kao:</p>
                            <p className="text-xl font-bold text-gray-900 mb-1">{confirmData.name} {confirmData.surname}</p>
                            <p className="text-sm text-gray-500 mb-6">({confirmData.username})</p>
                        </div>
                        <div className="flex gap-3">
                            <button onClick={handleCancel} className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 font-medium">
                                Odustani
                            </button>
                            <button onClick={handleConfirm} className="flex-1 px-4 py-2 bg-primary text-white rounded-lg hover:bg-yellow-700 font-medium">
                                Potvrdi prijavu
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
